<template>

  <div class="add-wine-row">
    <div>
      <b-row>
        <b-col cols="12" class="text-center">
          <LoadingAnimation v-if="loading" />
        </b-col>
      </b-row>
    </div>

    <div v-if="loading == false">
      <button v-if="inputIsHidden" @click="toggleInput()" class="iconButton add">{{
        $t('winelist.addWineModal.addWineRow') }}</button>
      <b-row v-else>
        <b-col class="col-px-width-24">
          <button @click="toggleInput()" class="cancel-button inline-row-button"></button>
        </b-col>
        <b-col style="flex-grow: 2">
          <b-form-input id="wineNameInput" ref="wineName" v-model="wineName"
            :placeholder="$t('winelist.addWineModal.wineNamePlaceholder')"></b-form-input>
        </b-col>
        <b-col>
          <SearchDataList id="categorySearch" ref="categorySearch"
            :searchFromOutside="selectedCategory.value ? selectedCategory.text : ''"
            :autoSuggestComplete="categories"
            :isLastSearch="false" :itemClickedFunction="handldeCategorySelected.bind(selectedCategory)"
            :placeholder="$t('winelist.addWineModal.categoryPlaceholder')" />
        </b-col>
        <b-col>
          <SearchDataList id="wineTypeSearch" ref="wineTypeSearch"
            :searchFromOutside="selectedWineType.value ? selectedWineType.text : ''"
            :autoSuggestComplete="wineTypeOptions" :isLastSearch="false"
            :itemClickedFunction="handleWineTypeSelected.bind(selectedWineType)"
            :placeholder="$t('winelist.addWineModal.colorPlaceholder')" />
        </b-col>
        <b-col>
          <SearchDataList id="grapeVarietySearch" ref="grapeVarietySearch" :disabled="checkIfWineTypeIsSelected"
            :searchFromOutside="selectedGrapeVariety.value ? selectedGrapeVariety.text : ''"
            :autoSuggestComplete="grapeVarietyOptions" :isLastSearch="false"
            :itemClickedFunction="handleGrapeVarietySelected.bind(selectedGrapeVariety)"
            :placeholder="$t('winelist.addWineModal.grapeVarietyPlaceholder')" />
        </b-col>
        <b-col class="col-px-width-24">
          <button @click="addWine()" class="inlineRow accept"
            :disabled="selectedCategory.value === null || checkIfWineTypeIsSelected || checkIfGrapeVarietyIsSelected"></button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DataService from '@/services/StrapiService'
import DataMappingService from '@/services/DataMappingService'
import LoadingAnimation from '@/components/LoadingAnimation.vue'
import Wine from '@/model/Wine.js'
import SearchDataList from '@/components/SearchDataList.vue'
import { mapGetters } from 'vuex'


export default {
  name: 'AddWineRow',
  components: {
    LoadingAnimation,
    SearchDataList
  },
  props: {
    selectedWinery: {
      type: Object,
      required: true
    },
    sheetRow: {
      type: Object,
      default: null
    }
  },
  emits: ['wineAdded'],
  data() {
    return {
      loading: false,
      inputIsHidden: true,
      wineTypeOptions: [],
      wineName: '',
      // Set to true once the sheet row prefill has been applied, so the
      // option watchers do not re-apply it and override user changes.
      prefillApplied: false,
      selectedWineType: {
        text: this.$t('general.dropdownText'),
        value: null
      },
      selectedGrapeVariety: {
        text: this.$t('general.dropdownText'),
        value: null
      },
      categories: [],
      selectedCategory: {
        text: this.$t('general.dropdownText'),
        value: null
      }
    }
  },
  mounted() {
    this.getWineTypeOptions()
    this.getCategories()
  },
  methods: {
    getWineTypeOptions() {
      this.showLoading()
      DataService.getAllWineTypes('title').then((response) => {
        this.hideLoading()
        this.wineTypeOptions = DataMappingService.mapGetAllWineTypesResponseToOptions(response)
      }).catch(() => {
        this.hideLoading()
        this.showErrorAlert(this.$t('errors.loadingError'))
      })
    },
    getCategories() {
      this.showLoading()
      DataService.getAllCategories().then((response) => {
        this.hideLoading()
        this.categories = DataMappingService.mapCategoryApiArrayToCategorOptions(response)
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i].localeKey !== 'wine' && this.categories[i].localeKey !== 'sparkling-wine') {
            var grapeVariety = this.getGrapeVarieties.find(grapeVariety => grapeVariety.category != null && grapeVariety.category.id != null && grapeVariety.category.id === this.categories[i].value)
            if (grapeVariety != null) {
              this.categories[i].grapeVariety = { text: grapeVariety.title, value: grapeVariety.id }
            }
          }
        }
      }).catch(() => {
        this.hideLoading()
        this.showErrorAlert(this.$t('errors.loadingError'))
      })
    },
    handleWineTypeSelected(wineTypeOption) {
      if (typeof wineTypeOption === 'object' && wineTypeOption !== null) {
        this.selectedWineType = wineTypeOption
      } else {
        if (this.wineTypeOptions.some(option => option.text === wineTypeOption)) {
          this.selectedWineType = this.wineTypeOptions.find(option => option.text === wineTypeOption)
        } else {
          this.resetSelectedWineType()
        }
      }
    },
    handleGrapeVarietySelected(selectedGrapeVariety) {
      if (typeof selectedGrapeVariety === 'object' && selectedGrapeVariety !== null) {
        this.selectedGrapeVariety = selectedGrapeVariety
      } else {

        if (this.selectedWineType.grapeVarieties.some(option => option.title === selectedGrapeVariety)) {
          var foundWineType = this.selectedWineType.grapeVarieties.find(option => option.title === selectedGrapeVariety)
          this.selectedGrapeVariety.value = foundWineType.id
          this.selectedGrapeVariety.text = foundWineType.title
        } else {
          this.resetSelectedGrapeVariety()
        }
      }
    },
    handldeCategorySelected(selectedCategory) {
      if (typeof selectedCategory === 'object' && selectedCategory !== null) {
        this.selectedCategory = selectedCategory
      } else {
        if (this.categories.some(option => option.text === selectedCategory)) {
          this.selectedCategory = this.categories.find(option => option.text === selectedCategory)
        } else {
          this.resetSelectedCategory()
        }
      }
    },
    /**
     * Add wine to database and emit event to add wine to selected wines in step 2 if successful, otherwise show error alert
     * If the winery is venue specific, the newly added wine will also be venue specific
     */
    async addWine() {

      console.log('Adding wine...', this.selectedWinery)

      const wine = new Wine()
      wine.title = this.wineName.trim()
      wine.region = { id: this.selectedWinery.region.id }
      wine.land = { id: this.selectedWinery.land.id }
      wine.grapeVariety = { id: this.selectedGrapeVariety.value }
      wine.wineType = { id: this.selectedWineType.value }
      wine.winery = { id: this.selectedWinery.id }
      wine.category = { id: this.selectedCategory.value }
      wine.classification = null

      if (this.selectedWinery.venue.id != null) {
        wine.venue = { id: this.selectedWinery.venue.id }
      }

      if (this.validateWine(wine) === false) {
        this.showErrorAlert(this.$t('errors.savingError'))
        return
      }

      const canCreateNewWine = await this.checkDuplicateWine(wine)
      if (canCreateNewWine === true) {
        this.sendCreateWineRequest(wine)
      } else {
        this.showErrorAlert(this.$t('winelist.addWineModal.wineAlreadyExists'))
      }
    },
    validateWine(wine) {
      return wine.title.length > 0 && wine.region.id != null && wine.land.id != null && wine.grapeVariety.id != null && wine.wineType.id != null && wine.winery.id != null
    },
    /**
     * Check if wine already exists in db
     * returns true if new wine can be created
     * @param {*} wine 
     */
    async checkDuplicateWine(wine) {
      this.showLoading()
      const response = await DataService.findWines(wine)
      const wines = DataMappingService.mapFindWinesResponse(response)
      const foundGeneralWine = wines.find(w => w.venue.id === null) !== undefined

      this.hideLoading()
      if (wines.length > 0 && foundGeneralWine) {
        return false
      } else {
        return true
      }
    },
    async sendCreateWineRequest(wine) {
      this.showLoading()
      await DataService.postWine(wine)
        .then((response) => {
          this.hideLoading()
          const wineResponse = DataMappingService.mapPostWineResponse(response)
          this.$emit('wineAdded', wineResponse)
          this.hideInput()
          this.resetUI()
          this.showSuccessAlert(this.$t('winelist.addWineModal.addedWines'))
        })
        .catch(() => {
          this.showErrorAlert(this.$t('errors.savingError'))
          this.hideLoading()
        })
    },
    showLoading() {
      this.loading = true
    },
    hideLoading() {
      this.loading = false
    },
    toggleInput() {
      this.inputIsHidden = !this.inputIsHidden
      this.resetUI()
    },
    /**
     * Open the input row and pre-fill the wine name, category, wine type
     * and grape variety from the sheet row (if available).
     *
     * Used when the sheet row's article name is not in the winery's wine
     * list, so the user can create the wine directly.
     *
     * @param {Object} sheetRow The sheet row with articleName, category,
     *   wineType and grapeVariety display values
     */
    prefill(sheetRow = null) {
      this.inputIsHidden = false
      if (sheetRow != null) {
        this.wineName = sheetRow.articleName || ''
        this.prefillCategory(sheetRow.category)
        this.prefillWineType(sheetRow.wineType)
        this.prefillGrapeVariety(sheetRow.grapeVariety)
        // Only mark the prefill as applied once the category, wine type and
        // grape variety could actually be matched against the loaded options.
        // If the options are still loading, the watchers re-apply the prefill
        // when they arrive (see reapplyPrefillIfOpen).
        this.prefillApplied = this.prefillWasFullyApplied(sheetRow)
      }
      this.$nextTick(() => {
        if (this.$refs.wineName != null) {
          this.$refs.wineName.focus()
        }
        // Directly sync the SearchDataList inputs, because their
        // searchFromOutside watcher may not fire reliably when the
        // prefill happens right after the components mount.
        this.syncSearchDataLists()
      })
    },
    /**
     * Whether the sheet row prefill values could be fully applied to the
     * currently loaded options.
     *
     * The prefill is considered applied when every value the sheet row
     * provides (category, wine type, grape variety) is either matched or
     * not applicable (e.g. no grape variety for a non-wine category).
     *
     * @returns {boolean}
     */
    prefillWasFullyApplied(sheetRow = null) {
      if (sheetRow == null) {
        return true
      }
      const categoryApplied = sheetRow.category == null || sheetRow.category === '' ||
        this.categories.some((c) => c.text.toLowerCase() === String(sheetRow.category).trim().toLowerCase())
      const wineTypeApplied = sheetRow.wineType == null || sheetRow.wineType === '' ||
        this.wineTypeOptions.some((t) => t.text.toLowerCase() === String(sheetRow.wineType).trim().toLowerCase())
      const grapeVarietyApplied = sheetRow.grapeVariety == null || sheetRow.grapeVariety === '' ||
        this.grapeVarietyOptions.some((g) => g.text.toLowerCase() === String(sheetRow.grapeVariety).trim().toLowerCase())
      return categoryApplied && wineTypeApplied && grapeVarietyApplied
    },
    /**
     * Apply the prefill values (without forcing the row open). Used by the
     * watchers when the options finish loading, so the prefill is applied
     * even if the options were not loaded yet when the sheetRow was set.
     *
     * Does NOT open the row if the user has closed it.
     */
    applyPrefillValues() {
      if (this.sheetRow == null) {
        return
      }
      if (this.sheetRow.articleName != null && this.sheetRow.articleName !== '') {
        this.wineName = this.sheetRow.articleName
      }
      this.prefillCategory(this.sheetRow.category)
      this.prefillWineType(this.sheetRow.wineType)
      this.prefillGrapeVariety(this.sheetRow.grapeVariety)
      // Mark the prefill as applied once all values could be matched, so
      // the option watchers do not re-apply it and override user changes.
      this.prefillApplied = this.prefillWasFullyApplied()
      this.$nextTick(() => {
        this.syncSearchDataLists()
      })
    },
    /**
     * Directly set the search text of the category, wine type and grape
     * variety SearchDataList inputs to the currently selected values.
     */
    syncSearchDataLists() {
      if (this.$refs.categorySearch != null) {
        this.$refs.categorySearch.search = this.selectedCategory.value ? this.selectedCategory.text : ''
      }
      if (this.$refs.wineTypeSearch != null) {
        this.$refs.wineTypeSearch.search = this.selectedWineType.value ? this.selectedWineType.text : ''
      }
      if (this.$refs.grapeVarietySearch != null) {
        this.$refs.grapeVarietySearch.search = this.selectedGrapeVariety.value ? this.selectedGrapeVariety.text : ''
      }
    },
    /**
     * Apply the prefill from the sheetRow prop. Called whenever the prop
     * changes or when the category / wine type options finish loading, so
     * the prefill is applied even if the options were not loaded yet when
     * the sheetRow was set.
     */
    prefillFromSheetRow() {
      if (this.sheetRow == null) {
        return
      }
      this.prefill(this.sheetRow)
    },
    /**
     * Watcher handler: re-apply the prefill values when the options finish
     * loading, but only if the row is currently open AND the prefill has
     * not been applied yet (so user changes are not overridden).
     */
    reapplyPrefillIfOpen() {
      if (this.inputIsHidden || this.prefillApplied) {
        return
      }
      this.applyPrefillValues()
    },
    /**
     * Match the sheet row's category display text against the loaded
     * category options and select it.
     *
     * @param {string} categoryText e.g. "Wein"
     */
    prefillCategory(categoryText) {
      if (categoryText == null || categoryText === '') {
        return
      }
      const category = this.categories.find(
        (c) => c.text.toLowerCase() === String(categoryText).trim().toLowerCase()
      )
      if (category != null) {
        this.selectedCategory = category
        // Selecting a category may reset wine type / grape variety via the
        // watcher, so re-apply them afterwards.
        this.$nextTick(() => {
          this.prefillWineType(this.sheetRow ? this.sheetRow.wineType : null)
          this.prefillGrapeVariety(this.sheetRow ? this.sheetRow.grapeVariety : null)
        })
      }
    },
    /**
     * Match the sheet row's wine type display text against the loaded
     * wine type options and select it.
     *
     * @param {string} wineTypeText e.g. "Weiß"
     */
    prefillWineType(wineTypeText) {
      if (wineTypeText == null || wineTypeText === '') {
        return
      }
      const wineType = this.wineTypeOptions.find(
        (t) => t.text.toLowerCase() === String(wineTypeText).trim().toLowerCase()
      )
      if (wineType != null) {
        this.selectedWineType = wineType
        // The grape variety options depend on the selected wine type, so
        // apply the grape variety prefill after the wine type has settled
        // (and after the category watcher may have reset it).
        this.$nextTick(() => {
          this.prefillGrapeVariety(this.sheetRow ? this.sheetRow.grapeVariety : null)
          this.syncSearchDataLists()
        })
      }
    },
    /**
     * Match the sheet row's grape variety display text against the
     * grape variety options of the selected wine type and select it.
     *
     * @param {string} grapeVarietyText e.g. "Chardonnay"
     */
    prefillGrapeVariety(grapeVarietyText) {
      if (grapeVarietyText == null || grapeVarietyText === '') {
        return
      }
      const grapeVariety = this.grapeVarietyOptions.find(
        (g) => g.text.toLowerCase() === String(grapeVarietyText).trim().toLowerCase()
      )
      if (grapeVariety != null) {
        this.selectedGrapeVariety = grapeVariety
        this.$nextTick(() => {
          this.syncSearchDataLists()
        })
      }
    },
    hideInput() {
      this.inputIsHidden = true
    },

    resetUI() {
      this.wineName = ''
      this.prefillApplied = false
      this.resetSelectedWineType()
      this.resetSelectedGrapeVariety()
      this.resetSelectedCategory()
      this.resetAlert()
    },
    resetSelectedGrapeVariety() {
      this.selectedGrapeVariety = {
        text: this.$t('general.dropdownText'),
        value: null
      }
      if (this.$refs.grapeVarietySearch != null) {
        this.$refs.grapeVarietySearch.deleteSearch()
      }
    },
    resetSelectedWineType() {
      this.selectedWineType = {
        text: this.$t('general.dropdownText'),
        value: null
      }
      if (this.$refs.wineTypeSearch != null) {
        this.$refs.wineTypeSearch.deleteSearch()
      }
    },
    resetSelectedCategory() {
      this.selectedCategory = {
        text: this.$t('general.dropdownText'),
        value: null
      }
      if (this.$refs.categorySearch != null) {
        this.$refs.categorySearch.deleteSearch()
      }
    },
    showErrorAlert(msg) {
      this.$root.$emit('showCreateWinesStep2Alert', { message: msg, type: 'warning' })
    },
    showSuccessAlert(msg) {
      this.$root.$emit('showCreateWinesStep2Alert', { message: msg, type: 'success' })
    },
    resetAlert() {
      this.$root.$emit('hideCreateWinesStep2Alert')
    },
    checkIfLocaleKeyIsWineOrSparklingWine(localeKey) {
      return localeKey === 'wine' || localeKey === 'sparkling-wine'
    }
  },
  watch: {
    selectedWineType: function (newVal, oldVal) {
      if (newVal.value !== oldVal.value) {
        if (this.selectedCategory.value === null || this.checkIfLocaleKeyIsWineOrSparklingWine(this.selectedCategory.localeKey)) {
          this.resetSelectedGrapeVariety()
        }
      }
    },
    selectedCategory: function (newVal, oldVal) {
      if (newVal.value !== oldVal.value && newVal.value !== null) {
        if (!this.checkIfLocaleKeyIsWineOrSparklingWine(newVal.localeKey)) {
          this.selectedWineType = this.wineTypeOptions.find(option => option.localeKey === 'na')
          this.selectedGrapeVariety = newVal.grapeVariety
        } else {
          this.resetSelectedWineType()
          this.resetSelectedGrapeVariety()
        }
      }
    },
    sheetRow: {
      handler() {
        this.prefillFromSheetRow()
      },
      immediate: true
    },
    categories: {
      handler() {
        this.reapplyPrefillIfOpen()
      }
    },
    wineTypeOptions: {
      handler() {
        this.reapplyPrefillIfOpen()
      }
    },
    grapeVarietyOptions: {
      handler() {
        this.reapplyPrefillIfOpen()
      }
    }
  },
  computed: {
    grapeVarietyOptions() {
      if (this.selectedWineType != null && this.selectedWineType.grapeVarieties != null) {
        const wineryGrapeVarietyIds = this.selectedWinery.land.grapeVarieties.map(grapeVariety => {
          return grapeVariety.id
        })
        const filteredGrapeVarieties = this.selectedWineType.grapeVarieties.filter(grapeVariety => {
          return wineryGrapeVarietyIds.includes(grapeVariety.id)
        })
        const options = filteredGrapeVarieties.map(grapeVariety => {
          return { text: grapeVariety.title, value: grapeVariety.id }
        })
        options.sort((a, b) => a.text.localeCompare(b.text))
        return options
      } else {
        return []
      }
    },
    checkIfWineTypeIsSelected() {
      return this.selectedWineType.value === undefined || this.selectedWineType.value === null || this.selectedWineType.value === ''
    },
    checkIfGrapeVarietyIsSelected() {
      return this.selectedGrapeVariety.value === undefined || this.selectedGrapeVariety.value === null || this.selectedGrapeVariety.value === ''
    },
    ...mapGetters(['getGrapeVarieties'])
  }
}

</script>
<style scoped></style>